import React from "react";
import { Form } from "semantic-ui-react";
import PropTypes from "prop-types";

/**
 * Campaign selector component
 */
const EmailCampaignSelector = ({
  campaignId,
  campaignOptions,
  onCampaignChange,
  disabled = false,
  required = true,
}) => {
  return (
    <Form.Select
      required={required}
      label="Campaign"
      options={campaignOptions}
      placeholder="Select a Campaign"
      onChange={onCampaignChange}
      value={campaignId}
      disabled={disabled}
    />
  );
};

EmailCampaignSelector.propTypes = {
  campaignId: PropTypes.number,
  campaignOptions: PropTypes.array.isRequired,
  onCampaignChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

export default EmailCampaignSelector;
